// extracted by mini-css-extract-plugin
export var boxesContainer = "paragraphs-with-boxes-module--boxes-container--UP-3s";
export var paragraph = "paragraphs-with-boxes-module--paragraph--B1DRI";
export var thirdParagraph = "paragraphs-with-boxes-module--third-paragraph--Msywv";